import { getSafeLabel } from 'organisms/QuestionConditionalLogic/utils'
import React from 'react'
import { QuestionType } from 'packages/question-types'

export function DropdownOptionText({ choice, questionType, isOpinionScale }) {
  const safeLabel = getSafeLabel(choice)

  if (!isOpinionScale) {
    return <span>{safeLabel}</span>
  }

  if (questionType === QuestionType.MULTIPLE_CHOICE) {
    return (
      <span>
        <span>{safeLabel}</span>
      </span>
    )
  }

  if (questionType === QuestionType.STAR) {
    return <span>{`${choice.value} Star${choice.value == 1 ? '' : 's'}`}</span>
  }

  if (questionType === QuestionType.SLIDER) {
    const isShowLabel = choice.value == 0 || choice.value == 10
    return (
      <>
        <span>{choice.value}</span>
        {isShowLabel && <span> - {safeLabel}</span>}
      </>
    )
  }

  if (questionType === QuestionType.RATING_SCALE_MINMAX) {
    const isShowLabel = choice.value == 1 || choice.value == 7
    return (
      <>
        <span>{choice.value}</span>
        {isShowLabel && <span> - {safeLabel}</span>}
      </>
    )
  }

  return null
}



// WEBPACK FOOTER //
// ./src/organisms/QuestionConditionModal/DropdownOptionText.tsx